// Copyright 2024 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license. See LICENSE.md in the collection root for license information.

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, take } from 'rxjs/operators';
import { SystemPermission, SystemPermissionsService } from 'src/app/generated/blueprint.api';

@Injectable({
  providedIn: 'root',
})
export class PermissionDataService {
  private _permissions: SystemPermission[] = [];
  get permissions(): SystemPermission[] {
    return this._permissions;
  }

  constructor(
    private permissionsService: SystemPermissionsService,
  ) { }

  load(): Observable<SystemPermission[]> {
    return this.permissionsService.getMySystemPermissions().pipe(
      take(1),
      tap((x) => (this._permissions = x))
    );
  }

  hasPermission(permission: SystemPermission) {
    return this._permissions.includes(permission);
  }

  canViewAdministration() {
    return this._permissions.some((y) => y.startsWith('View'));
  }
}
